(() => {
  if (window.fitwoodStudioCreditInitialized) return;
  window.fitwoodStudioCreditInitialized = true;
  const read = (el, selector) => JSON.parse(el.querySelector(selector).textContent);
  function activeRate(config) {
    const rate = Number(config.campaignRate);
    const end = config.campaignEnd ? Date.parse(config.campaignEnd) : NaN;
    return rate > 0 && (!config.campaignEnd || (Number.isFinite(end) && Date.now() <= end)) ? rate : 0;
  }
  function range(config) {
    const campaign = activeRate(config);
    return campaign ? campaign + '%' : config.tiers[0].rate + '–' + config.tiers[config.tiers.length - 1].rate + '%';
  }
  const observedButtons = new WeakSet();
  const buttonObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => requestAnimationFrame(update)) : null;
  function update() {
    document.querySelectorAll('[data-studio-credit-product]').forEach(el => {
      try {
        const config = read(el, '[data-credit-config]');
        const variants = read(el, '[data-credit-variants]');
        const headline = el.querySelector('[data-credit-product-headline]');
        const root = el.closest('.fw-pdp-main');
        const buyButton = root?.querySelector('[data-add-to-cart]');
        if (buyButton) {
          const width = buyButton.getBoundingClientRect().width;
          if (width > 0) el.style.width = width + 'px';
          if (buttonObserver && !observedButtons.has(buyButton)) {
            observedButtons.add(buyButton);
            buttonObserver.observe(buyButton);
          }
        }
        const selectedId = root?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || root?.querySelector('[name="id"]')?.value || headline.dataset.initialId;
        const variant = variants.find(v => String(v.id) === String(selectedId));
        const quantityInput = root?.querySelector('[name="quantity"]');
        const quantity = Math.max(1, Number(quantityInput?.value) || 1);
        const currency = config.currency;
        const rate = currency === 'EUR' ? 1 : config.shopCurrency === 'EUR' && window.Shopify?.currency?.active === currency ? Number(window.Shopify.currency.rate) : NaN;
        if (!variant || !Number.isFinite(rate) || rate <= 0) {
          headline.textContent = headline.dataset.fallback.replaceAll('[[rate]]', range(config));
          return;
        }
        const total = variant.price * quantity;
        const totalEUR = total / rate;
        const tier = [...config.tiers].reverse().find(t => totalEUR >= t.threshold) || config.tiers[0];
        const percent = activeRate(config) || tier.rate;
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(Math.round(total * percent / 100) / 100);
        const text = headline.dataset.template.replaceAll('[[amount]]', amount).replaceAll('[[rate]]', percent + '%');
        if (headline.textContent !== text) headline.textContent = text;
      } catch (_) {}
    });
    document.querySelectorAll('[data-studio-credit-story]').forEach(el => {
      try {
        const config = read(el, '[data-credit-config]');
        el.querySelectorAll('[data-credit-range-copy]').forEach(copy => {
          const text = copy.dataset.creditRangeCopy.replaceAll('[[rate]]', range(config));
          if (copy.textContent !== text) copy.textContent = text;
        });
        el.querySelectorAll('[data-credit-tier-rate]').forEach(tierEl => {
          const rate = activeRate(config) || config.tiers[Number(tierEl.dataset.creditTierRate)]?.rate;
          const text = rate + '%';
          if (tierEl.textContent !== text) tierEl.textContent = text;
        });
      } catch (_) {}
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-studio-credit-jump]');
    if (!link) return;
    const target = document.getElementById('studio-credit');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
  });
  ['input','change','theme:variant:change','variant:change','shopify:section:load'].forEach(name => document.addEventListener(name, () => requestAnimationFrame(update)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true}); else update();
  window.addEventListener('pageshow', update);
})();
